import * as queryString from 'query-string'

import Base from './base'
import { withAutoCancellation } from '../services/request'

export default class Cadences extends Base {
  DEFAULT_PARAMS = {
    per_page: 100,
    page: 1,
    sort_direction: 'ASC',
  }
  PERSONAL_CADENCES_PATH = 'cadences_v3.json'
  TEAM_CADENCES_PATH = 'teams/team_cadences.json'

  index(path, query, config) {
    return this.api.get(`${path}?${query}`, config)
  }

  stages() {
    return this.api.get(`cadence_stages.json`)
  }

  async add({ cadenceId, personId, stepId, assignToId }) {
    return this.api.post('people_v2/add_to_cadence.json', {
      ids: [personId],
      cadence_to_add_to: cadenceId,
      step_id: stepId || null,
      account_to_assign_to: assignToId || null,
    })
  }

  async remove(cadenceId, personId) {
    return this.api.post('cadence_people/remove_from_cadence.json', {
      cadence: cadenceId,
      ids: [personId],
    })
  }

  async all(path, page, queryParams, config) {
    const query = { ...this.DEFAULT_PARAMS, page, ...queryParams }
    const json = await this.index(
      path,
      queryString.stringify(query, { arrayFormat: 'bracket' }),
      config
    )
    const objects = json.cadences
    const totalPages = json.meta.total_pages

    if (totalPages < 2) {
      return objects
    }

    const requests = []
    for (let pageNumber = 2; pageNumber <= totalPages; pageNumber += 1) {
      requests.push(this.index(path, queryString.stringify({ ...query, page: pageNumber }), config))
    }
    const responses = await Promise.all(requests)
    const results = responses.reduce((result, response) => [...result, ...response.cadences], [])
    return objects.concat(results)
  }

  fetchAll = withAutoCancellation((...args) => this.all(...args))
}
